// https://github.com/getsentry/sentry-javascript/issues/3440
export const SENTRY_IGNORE_ERRORS = ['Non-Error promise rejection captured'];
